import React from "react";
import ReactDOM from "react-dom";
import { ApolloProvider } from "react-apollo";
import { BrowserRouter as Router } from "react-router-dom";
import App from "./components/App";
import registerServiceWorker from "./registerServiceWorker";
import Amplify from "aws-amplify";
import cognito from "./config/cognito";
import client from "./apolloClient";
import "./include/styles";
import "./include/bootstrap";
import "./include/fontawesome";

const url = "https://lambda.us-east-2.amazonaws.com/2015-03-31/functions";

Amplify.configure({
  Auth: {
    identityPoolId: cognito.identityPoolId,
    region: cognito.region,
    userPoolId: cognito.userPoolId,
    userPoolWebClientId: cognito.userPoolWebClientId
  },
  API: {
    endpoints: [
      {
        name: "analyze_genes",
        endpoint:
          process.env.NODE_ENV === "production"
            ? `${url}/rnama-rpy2-production-analyze_genes/invocations`
            : "http://localhost:4001/analyze_genes",
        service: "lambda",
        region: "us-east-2"
      },
      {
        name: "search_geo",
        endpoint:
          process.env.NODE_ENV === "production"
            ? `${url}/rnama-rpy2-production-search_geo/invocations`
            : "http://localhost:4001/search_geo",
        service: "lambda",
        region: "us-east-2"
      }
    ]
  },
  Storage: {
    bucket: "rnama-assets",
    region: "us-east-2"
  }
});

ReactDOM.render(
  <ApolloProvider client={client}>
    <Router>
      <App />
    </Router>
  </ApolloProvider>,
  document.getElementById("root")
);
registerServiceWorker();



// WEBPACK FOOTER //
// ./src/index.js